import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import AsSelectedTestResults from './AssignValuesSection';
import AsAvailableTestsGrid from './AvailableTestsGrid';
import { AsTestQuerySection } from './TestQuerySection';

let AsValueAssignmentSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <AsTestQuerySection />
      <AsAvailableTestsGrid />
      <AsSelectedTestResults />
    </>
  );
};

AsValueAssignmentSection = withInjectedProps(AsValueAssignmentSection);

export { AsValueAssignmentSection };
export default AsValueAssignmentSection;
